import React, { Component } from "react";
import PropTypes from "prop-types";
import { CSSTransitionGroup } from 'react-transition-group';
import RVMTemplatesCategorySelect from "./RVMTemplatesCategorySelect";
import AudioRecord from "./AudioRecord";
import AudioPlayback from "./AudioPlayback";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import * as Constants from '../constants';
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";

import S3 from 'aws-sdk/clients/s3';
import { getS3FilebrowserDirectory, getS3Tokens } from "../actions/index";

class RVMTemplatesForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    rvm_template_category_id: PropTypes.number.isRequired,
    categories: PropTypes.array,
    handleSendTestRVM: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      name: this.props.name,
      mode: this.props.mode,
      rvm_template_category_id: this.props.rvm_template_category_id,
      categories: this.props.categories,
      s3_url: this.props.s3_url,
      old_s3_url: this.props.s3_url,
      errors: {},
      test_rvm_number: "",
      accessKeyId: null,
      secretAccessKey: null,
      sessionToken: null,
      fileBlob: null,
      showModal: false,
    };
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  openModal() {
    this.setState({ showModal: true });
  }


  componentDidMount() {
    this.props.getS3FilebrowserDirectory()
      .then(response => {
        if (response.payload.status == 200) {
          let s3_browser_directory = response.payload.data.directory;
          let creds_url =
              process.env.API_ROOT_URL +
              "/s3_browser/access_token?X-Site-UUID=" +
              localStorage.getItem('lastSiteUUID') +
              "&directory=" +
              s3_browser_directory
          this.props
            .getS3Tokens(creds_url)
            .then(response => {
              if (response.payload.status == 200) {
                this.setState({
                  s3_status: "show",
                  s3_browser_directory: s3_browser_directory,
                  accessKeyId: response.payload.data.AccessKeyId,
                  secretAccessKey: response.payload.data.SecretAccessKey,
                  sessionToken: response.payload.data.SessionToken
                });
              }
            });
          }
      });
  }

  handleChangeName(e) {
    this.setState({ name: e.target.value });
  }

  handleChangeTestRVMNumber(e) {
    this.setState({ test_rvm_number: e.target.value });
  }

  handleSelectCategory(rvm_template_category_id) {
    this.setState({ rvm_template_category_id: rvm_template_category_id });
  }

  handleFinishRecord(data) {
    console.log('handleFinishRecord');
    console.log(data);
    this.setState({ fileBlob: data });
  }

  handleUpload(s3_url) {
    this.setState({ s3_url: s3_url });
    this.validate();
    if (Object.keys(this.state.errors).length == 0) {
      this.props.handleSubmit(this.state);
      this.closeModal();
    }
  }

  onDeleteClickConfirmation() {
    const msg =
      "Are you sure you want to delete this template? You cannot undo deletion.";
    const toastrConfirmOptions = {
      onOk: () => this.props.handleDelete()
    };
    toastr.confirm(msg, toastrConfirmOptions);
  }

  syncToS3(callbackFunction) {
    if ( this.state.fileBlob == null ) {
      console.log('nothing changed in the file');
      callbackFunction(this.state.s3_url);
      return true;
    }

    // Create S3 Client
    const config = {
      apiVersion: '2006-03-01',
      region: 'us-east-1',
      accessKeyId: this.state.accessKeyId,
      secretAccessKey: this.state.secretAccessKey,
      sessionToken: this.state.sessionToken,
      correctClockSkew: true,
      params: {
          Bucket: 'u.realgeeks.media',
        },
    }
    const client = new S3( config );

    // Delete old s3 file if it exists
    if (this.state.old_s3_url != null && this.state.fileBlob != null) {
      const pathArr = this.state.old_s3_url.split('/');
      const oldFileName = pathArr[pathArr.length - 1];
      const deleteParams = {
            Bucket: 'u.realgeeks.media',
            Key: this.state.s3_browser_directory + "/voicemails/" + oldFileName
          };
      client.deleteObject(deleteParams, function(err, data) {
        console.log(err, data);
      });
    }

    // Upload new file to s3
    const path = this.state.s3_browser_directory + "/voicemails/" + this.state.fileBlob.name;
    const d = {
          Body: this.state.fileBlob,
          Key: path,
          ContentType: this.state.fileBlob.type,
        };

    client.upload(d, function(err, data) {
      callbackFunction(data.Location);
      // console.log(err, data);
      // that.setState({ s3_url: data.Location });
    });
  }

  sendTestRVM() {
    this.validate();
    if (this.state.test_rvm_number == "") {
      toastr.error("Enter phone number to send test RVM.");
      return false;
    }
    if (Object.keys(this.state.errors).length == 0) {
      let prms = {
        message: {
          phone_number: this.state.test_rvm_number,
          s3_url: this.state.s3_url
        }
      };
      this.props.handleSendTestRVM(prms);
    }
  }

  rerecord() {
    this.setState({ mode: 'new' });
  }

  rerecordConfirmation() {
    const msg = "Are you sure you want to record again?\nThis will permenantly delete your previous recording.";
    const toastrConfirmOptions = { onOk: () => this.rerecord() };
    toastr.confirm(msg, toastrConfirmOptions);
  }

  validate() {
    // this.validateNotEmpty("name", "Please enter a name for your email.");
    // this.validateNotEmpty(
    //   "body_text",
    //   "Please enter a body for your email.",
    //   true
    // );
    // this.validateLength("body_text", 0, 1024);
    // if (this.state.errors.body_text === undefined) {
    //   this.validateTokens(
    //     "body_text",
    //     "The body contains invalid merge fields.",
    //     true
    //   );
    // }
  }

  save(e) {
    e.preventDefault();
    this.openModal();
    this.syncToS3(this.handleUpload.bind(this));
  }

  recOrPlayAudio() {
    if (this.state.mode == 'new') {
      return (
        <AudioRecord handleFinishRecord={this.handleFinishRecord.bind(this)} />
      )
    } else {
      return (
        <AudioPlayback s3_url={this.state.s3_url} />
      )
    }

  }

  render() {
    let { id, name, handleSubmit } = this.props;
    if (!name && id) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div id="content" className="spinner-content">
            <div className="vertical-center">
              <i className="fa fa-refresh fa-4x fa-spin" />
            </div>
          </div>
        </CSSTransitionGroup>
      );
    }
    return (
      <form onSubmit={this.save.bind(this)}>
        <div
          className={`form-group ${this.state.errors.name ? "has-error" : ""}`}
        >
          <label>Name</label>
          <input
            type="text"
            className="form-control name_field"
            onChange={this.handleChangeName.bind(this)}
            value={this.state.name}
          />
          <div className="help-block">{this.state.errors.name}</div>
        </div>

        <div
          className={`form-group ${
            this.state.errors.category_id ? "has-error" : ""
          }`}
        >
          <label>Category</label>
          <RVMTemplatesCategorySelect
            match={this.props.match}
            handleSelectCategory={this.handleSelectCategory.bind(this)}
            categories={this.state.categories}
            rvm_template_category_id={this.state.rvm_template_category_id}
          />
          <div className="help-block">{this.state.errors.category_id}</div>
        </div>

        <div
          className={`form-group ${
            this.state.errors.category_id ? "has-error" : ""
          }`}
        >
          <label>Recording (Maximum Duration: 20 sec)</label>
          { this.recOrPlayAudio() }

          <div className="help-block">{this.state.errors.category_id}</div>
        </div>

        <span className={`${this.props.inline == 'true' ? 'hide': ''}`}>
          <Link
            to={`/rvm_templates?${Constants.DEFAULT_PAGINATION}`}
            className="btn btn-default pull-left m-r-10"
          >
            Back
          </Link>
        </span>
        <div
          onClick={this.rerecordConfirmation.bind(this)}
          className={`btn pull-left btn-primary m-r-10 ${this.state.mode == 'edit' ? '': 'hide'}`}
          >
          Record Again
        </div>
        <span className={`${this.props.inline == 'true' ? 'hide': ''}`}>
          <Link
            className="btn btn-danger pull-left delete_template_btn m-r-10"
            onClick={this.onDeleteClickConfirmation.bind(this)}
          >
            Delete Template
          </Link>
        </span>


        <button type="submit" className="btn pull-right btn-primary">
          Save
        </button>
        <div className={`input-group send_test_rvm m-r-10 ${this.state.mode == 'edit' ? '': 'hide'}`} >
          <input
            type="text"
            className="form-control test_rvm_number_field"
            onChange={this.handleChangeTestRVMNumber.bind(this)}
            placeholder="888-123-4567"
            value={this.state.test_rvm_number}
          />
          <div className="input-group-btn">
            <div className="btn btn-primary" onClick={this.sendTestRVM.bind(this)}>
              Send Test Voicemail
            </div>
          </div>
        </div>

        <Modal
          show={this.state.showModal}
          onHide={this.closeModal.bind(this)}
          backdrop="static"
          keyboard={false}
          autoFocus={true}
          enforceFocus={true}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title id="contained-modal-title-lg">
              Saving . . .
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="vertical-center">
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              >
                <i className="fa fa-refresh fa-4x fa-spin" />
              </CSSTransitionGroup>
            </div>
          </Modal.Body>
        </Modal>
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  { getS3FilebrowserDirectory, getS3Tokens }
)(RVMTemplatesForm);
